module.exports = __webpack_public_path__ + "img/dinamo_pb_icon_dark.47da4495.png";